export enum Variables {
    TOKEN_LOCALSTORAGE = 'TOKEN_CAFEAPP_GRANJAZUL',
    PAYLOAD = 'PERSONA'
  }